import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Layout } from "./components/Layout";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Loader2 } from "lucide-react";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import UploadPage from "./pages/Upload";
import Documents from "./pages/Documents";
import DocumentDetail from "./pages/DocumentDetail";
import ReviewQueue from "./pages/ReviewQueue";
import Payments from "./pages/Payments";
import Fleet from "./pages/Fleet";
import Exports from "./pages/Exports";
import Users from "./pages/Users";
import "./App.css";

const FullScreenLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-[hsl(var(--background))]">
    <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
  </div>
);

const RequireAuth = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return <FullScreenLoader />;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return children;
};

const RequireWriter = ({ children }) => {
  const { isWriter } = useAuth();
  if (!isWriter) return <Navigate to="/" replace />;
  return children;
};

const RequireAdmin = ({ children }) => {
  const { isAdmin } = useAuth();
  if (!isAdmin) return <Navigate to="/" replace />;
  return children;
};

const AppShell = () => (
  <RequireAuth>
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/upload" element={<RequireWriter><UploadPage /></RequireWriter>} />
        <Route path="/documents" element={<Documents />} />
        <Route path="/documents/:id" element={<DocumentDetail />} />
        <Route path="/review" element={<ReviewQueue />} />
        <Route path="/payments" element={<Payments />} />
        <Route path="/fleet" element={<Fleet />} />
        <Route path="/exports" element={<Exports />} />
        <Route path="/users" element={<RequireAdmin><Users /></RequireAdmin>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  </RequireAuth>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/*" element={<AppShell />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
